<template>
    <div class="body">
		<p  class="font1" style="padding-top: 8vh;">根据您的学习期望，精选课程助您成长提升。</p>

		<div style="width: 90%;margin: 0 auto;margin-top: 2vh;">
			<!-- <p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 第一季度主题课程推荐：</p> -->
			<ul v-for="(item, index) in sloganRecommend" :key="index" style="margin: 0 auto;">
                <li @click="redirectToSolganCourse(item.Name,item.Link)" style="padding: 0;margin-top: 0;">{{ item.Name }}</li>
			</ul>
		</div>
    </div>
</template>
<!-- 010221 -->
<script>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
export default {
    props: ["ReportData"],
    data() {
		return {
			sloganRecommend:[],
		}
    }, 
    created(){
		if(this.ReportData.sloganRecommend !== null){
			this.sloganRecommend=JSON.parse(this.ReportData.sloganRecommend)
		}
    },
    methods: {
        redirectToSolganCourse(Name,Link){
            var dataForm = {};
            dataForm.studyList=Name,
            // console.log(dataForm,'课程')
            window.location.href = Link
            this.$emit('redirectToSolganCourse', dataForm);  
        },
    },
}
</script>
  
<style scoped>
.body {
	background: 
				url("../../assets/25March/logo.png") right  top  no-repeat,
				url("../../assets/25May/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #26a5e1;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>